import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../app/providers/AuthProvider";
import LoadingSpinner from "../../../shared/ui/LoadingSpinner";
import { canAccessReportDesigner } from "../../../shared/permissions";
import RouteFallback from "./RouteFallback";

/**
 * Gate `/reports/designer` with the same rule as the Sidebar designer link.
 * Do not use RequirePermission(settings.edit) alone — that would drop legacy
 * job_id >= 70 admins who may lack an explicit settings.edit grant.
 */
export default function RequireReportDesigner({ children, fallback = "/" }) {
  const { loading, isAuthenticated, profile } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessReportDesigner(profile)) {
    return <RouteFallback fallback={fallback} />;
  }

  return children;
}
